import img1 from "../img/Machine/1.png";
import img2 from "../img/Machine/2.png";
import img3 from "../img/Machine/3.png";
import img4 from "../img/Machine/4.png";
import img5 from "../img/Machine/5.png";
import img6 from "../img/Machine/6.png";
import img7 from "../img/Machine/7.png";
import img8 from "../img/Machine/8.png";

const Data = [
    {
        id:1,
        name: 'HAAS',
        desc: '750ss',
        img: img1,
    },
    {
        id:2,
        name: 'Matsuura',
        img: img2,
        desc: 'MX-520'
    },
    {
        id:3,
        name: 'Matsuura',
        img: img3,
        desc: 'MX-850'
    },
    {
        id:4,
        name: 'HASS',
        img: img4,
        desc: 'VF 6ss'
    },
    {
        id: 5,
        name: "DOOSAN",
        img: img7,
        desc: "6500 5 Axis"
    },
    {
        id: 6,
        name: "DOOSAN",
        img: img6,
        desc: "5000 5 Axis"
    },
    {
        id: 7,
        name: "HASS",
        img: img8,
        desc: "VF9"
    },
    {
        id:8,
        name: 'ALTEK',
        img: img5,
        desc: 'CMM'
    },
];

export default Data;